export enum TabsId {
  Avatars = 'TabAvatars',
  Places = 'TabPlaces',
  Players = 'TabPlayers',
  Invite = 'TabInvite',
  Container = 'Container',
  VR = 'VR',
  PC = 'PC',
}
